import { Injectable } from "@angular/core";
import { LeadsFilaItem } from "../../interfaces/leads-fila.interface";

@Injectable({
    providedIn: 'root'
})
export class RenewPlusHelperService {
    mapRenovaMais(item: LeadsFilaItem): string {
        const flagRenovacao = this.obterFlagRenovacao(item);
        const isRenovaMais = flagRenovacao !== null ? flagRenovacao : item.renovaMais === true;
        return isRenovaMais ? 'renewalBlue' : 'renewalGrey';
    }

    private obterFlagRenovacao(item: LeadsFilaItem): boolean | null {
        const flag = (item as any).flag_renovacao ?? (item as any).flRenovacao ?? (item as any).flagRenovacao;
        if (flag === 'S') return true;
        if (flag === 'N') return false;
        return null;
    }
}